export default "__VITE_ASSET__gS$DAR5H__"